import { IconName } from '@fortawesome/fontawesome-svg-core';
import { IlLocation, IlLocationTypeEnum } from '@queries/generated';

const iconMap: Record<IlLocationTypeEnum, IconName> = {
  [IlLocationTypeEnum.IlOnlineLocation]: 'globe',
  [IlLocationTypeEnum.IlPhysicalLocation]: 'map-marker-alt'
};

export function iconForLocation(location: IlLocation): IconName {
  return iconMap[location?.type] || 'question';
}
